import React from 'react';
import { connect } from 'react-redux';
import { filter, forEach, map, values, addIndex } from 'ramda';

import SelectField from 'material-ui/SelectField';
import IconButton from 'material-ui/IconButton';
import Add from 'material-ui/svg-icons/content/add-circle-outline';
import Remove from 'material-ui/svg-icons/content/remove-circle-outline';
import MenuItem from 'material-ui/MenuItem';

import { fetchPdaList } from '../../services/Api';
import { EMetric } from '../../constants/Enums';

const renderMetrics = () => {
  return map(m => <MenuItem key={m.key} value={m.key} primaryText={m.label} />, values(EMetric));
};

const renderPDAs = pdaList => {
  return map(p => <MenuItem key={p.value} value={p.value} primaryText={p.label} />, filter(p => !p.header, pdaList));
};

const ETagType = {
  METRIC: {
    key: 'METRIC',
    label: 'Metric'
  },
  PDA: {
    key: 'PDA',
    label: 'Personal Development Area'
  }
};

const renderTagTypes = () => {
  return map(t => <MenuItem key={t.key} value={t.key} primaryText={t.label} />, values(ETagType));
};

class OpportunityTags extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tags: [],
      pdaList: [],
      items: []
    };
  }

  componentDidMount = () => {
    fetchPdaList(this.props.auth.access_token).then(res => {
      const pdaList = res.body.payload.personalDevelopmentAreas;
      const q = [pdaList];
      const result = [];
      while (q.length) {
        const arr = q.shift();
        forEach(item => {
          if (item.children) {
            q.push(item.children);
          } else if (!item.header) {
            result.push({ value: '' + item.value, label: item.label });
          }
        }, arr);
      }
      this.setState({
        pdaList: result
      });
    });
    this.setTagsFromProps(this.props.tags);
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.tags !== nextProps.tags) {
      this.setTagsFromProps(nextProps.tags);
    }
  }

  setTagsFromProps = tags => {
    if (this.props.onChange) {
      this.setState({ tags });
    }
  };
  setTags = tags => {
    if (this.props.onChange) {
      this.props.onChange(tags);
    } else {
      this.setState({ tags });
    }
  };

  addTag = () => {
    this.setTags([...this.state.tags, {}]);
  };

  removeTag = index => {
    const tags = addIndex(filter)((v, idx) => idx !== index, this.state.tags);
    this.setTags(tags);
  };

  handleChangeType = (e, index, value) => {
    const tags = [...this.state.tags];
    tags[index].type = value;
    this.setTags(tags);
  };

  handleChangeValue = (e, index, value) => {
    const tags = [...this.state.tags];
    tags[index].value = value;
    this.setTags(tags);
  };

  render() {
    const { tags } = this.state;
    return (
      <div>
        {addIndex(map)((val, idx) => {
          const idPart = `${idx}-${val.type || 'NONE'}-${val.value || 'NONE'}`;
          const tagId = `tag-${idPart}`;
          const valueId = `value-${idPart}`;
          return (
            <div key={idPart} className={'flex flex1 flex-wrap flex-align-center'}>
              <div className="flex1">
                <SelectField
                  name={tagId}
                  id={tagId}
                  floatingLabelText={'Type'}
                  floatingLabelFixed
                  hintText={'Type'}
                  value={val.type}
                  fullWidth
                  onChange={(e, x, value) => this.handleChangeType(e, idx, value)}
                >
                  {renderTagTypes()}
                </SelectField>
              </div>
              <div className="flex1">
                <SelectField
                  floatingLabelText={'Value'}
                  floatingLabelFixed
                  hintText={'Value'}
                  name={valueId}
                  id={valueId}
                  value={val.value}
                  onChange={(e, x, value) => this.handleChangeValue(e, idx, value)}
                  fullWidth
                  disabled={!val.type}
                >
                  {val.type === ETagType.METRIC.key && renderMetrics()}
                  {val.type === ETagType.PDA.key && renderPDAs(this.state.pdaList)}
                </SelectField>
              </div>
              <div>
                <IconButton tooltip="Remove tag" onClick={() => this.removeTag(idx)}>
                  <Remove />
                </IconButton>
              </div>
            </div>
          );
        }, tags)}
        <IconButton tooltip="Add tag" onClick={this.addTag}>
          <Add />
        </IconButton>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    auth: state.auth
  };
};
export default connect(mapStateToProps)(OpportunityTags);



// WEBPACK FOOTER //
// ./src/components/basic/OpportunityTags.js